import { createRoute } from '@tanstack/react-router';
import { OnboardingFlow } from '@/features/onboarding';
import { rootRoute } from './__root';

export const onboardingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/onboarding',
  component: OnboardingPage,
});

function OnboardingPage() {
  return (
    <div className="min-h-[100dvh] bg-mf-neutral-50">
      <OnboardingFlow />
    </div>
  );
}
